import { Skeleton } from '@chakra-ui/react';
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { FundingRequestApproveRoute } from './FundingRequestApproveRoute';
import { FundingRequestRoute } from './FundingRequestRoute';
import { FundingRequestHistoryWithVerificationRoute } from 'packages/funding-requests/routes/FundingRequestHistoryWithVerificationRoute';
import { VerificationEligibilityRoute } from 'packages/funding-requests/routes/VerificationEligibilityRoute';
import { VerificationHistoryRoute } from 'packages/funding-requests/routes/VerificationHistoryRoute';
import { VerificationWorkflowRoute } from 'packages/funding-requests/routes/VerificationWorkflowRoute';
import { useGetLenderVerificationCreditFacilitiesQuery } from 'packages/verifications/requests/requests.gql.generated';
import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';

// Exports
export const FundingRequestRouter = () => {
  const { user } = useUserAuthOrThrow();
  const {
    data: creditFacilitiesData,
  } = useGetLenderVerificationCreditFacilitiesQuery({
    variables: { organizationId: user.organizationId },
  });
  if (
    !creditFacilitiesData ||
    !creditFacilitiesData.lenderVerificationCreditFacilities
  ) {
    return (
      <Skeleton
        data-testid="loading-lender-verification-container"
        height="300px"
      />
    );
  }

  const { lenderVerificationCreditFacilities } = creditFacilitiesData;
  const enableVerifications = !!lenderVerificationCreditFacilities.length;

  return (
    // Paths relative to "/funding-requests/*"
    <Routes>
      {/* --- Funding request routes --- */}
      <Route
        path="/"
        element={
          <FundingRequestHistoryWithVerificationRoute
            enableVerifications={enableVerifications}
          />
        }
      />
      <Route path="/:fundingRequestId" element={<FundingRequestRoute />} />
      <Route
        path="/:fundingRequestId/approve"
        element={<FundingRequestApproveRoute />}
      />

      {/* --- Funding verification routes --- */}
      <Route
        path="/verifications/new"
        element={
          enableVerifications ? (
            <VerificationWorkflowRoute />
          ) : (
            <Navigate to="/funding-requests" />
          )
        }
      />
      <Route
        path="/verifications/pipeline/history"
        element={
          enableVerifications ? (
            <VerificationHistoryRoute />
          ) : (
            <Navigate to="/funding-requests" />
          )
        }
      />
      <Route
        path="/verifications/pipeline/:artifactDocumentId/:creditFacilityId/:reportingDate/:fileVersion"
        element={
          enableVerifications ? (
            <VerificationWorkflowRoute />
          ) : (
            <Navigate to="/funding-requests" />
          )
        }
      />
      <Route
        path="/verifications/pipeline/:artifactDocumentId/:creditFacilityId/:reportingDate/:fileVersion/:verificationReportId/eligibility"
        element={
          enableVerifications ? (
            <VerificationEligibilityRoute />
          ) : (
            <Navigate to="/funding-requests" />
          )
        }
      />

      <Route path="/*" element={<Navigate to="/funding-requests" />} />
    </Routes>
  );
};
